import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import merge from "lodash/merge"
import cloneDeep from "lodash/cloneDeep"
import axios from "axios"
import { API_URL, USER_API_URL, FILE_API_URL, AUTH_PROVIDER_DOMAIN } from "env"
import { timestampConfig } from "./axios-config"

const errorResponseHandler = e => Promise.reject(get(e, "response", e))

axios.interceptors.response.use(
  response => response.data,
  error => {
    throw error.response
  }
)

// ====== instance for after login api =====
let afterLoginRequestInterceptorId = null
const afterLoginInstance = axios.create({
  baseURL: USER_API_URL
})

afterLoginInstance.interceptors.response.use(
  response => response.data,
  errorResponseHandler
)

// ====== instance for user api =====
const userApiInstance = axios.create({
  baseURL: USER_API_URL
})

// TODO: Check if user api instance can implement interceptor to automatically attach access token
userApiInstance.interceptors.request.use(config => {
  merge(config, timestampConfig())
  return config
})

userApiInstance.interceptors.response.use(
  response => response.data,
  error => {
    throw error.response
  }
)

// ====== instance for before login api =====
const beforeLoginInstance = axios.create({
  baseURL: API_URL
})

beforeLoginInstance.interceptors.response.use(
  response => response,
  error => {
    throw error
  }
)

beforeLoginInstance.interceptors.request.use(config => {
  merge(config, timestampConfig())
  return config
})

// ====== instance for file api =====
let fileApiRequestInterceptorId = null
const fileApiInstance = axios.create({
  baseURL: FILE_API_URL
})

fileApiInstance.interceptors.response.use(
  response => response,
  errorResponseHandler
)

// ====== instance for gateway api =====
let mainApiRequestInterceptorId = null
const mainApiInstance = axios.create({
  baseURL: API_URL
})

mainApiInstance.interceptors.response.use(
  response => response.data,
  errorResponseHandler
)

// ====== inject request interceptor =====
const injectRequestInterceptor = ({ getAccessToken }) => {
  const requestInterceptor = async config => {
    const defaultConfig = {
      headers: {
        post: {
          "Content-Type": "application/json"
        }
      }
    }
    const configMerge = merge(cloneDeep(defaultConfig), config)
    const headers = get(configMerge, "headers", {})
    const accessToken = await getAccessToken()

    if (!isEmpty(accessToken)) {
      headers.Authorization = `Bearer ${accessToken}`
    }

    return { ...configMerge, headers, ...timestampConfig() }
  }

  if (fileApiRequestInterceptorId !== null) {
    fileApiInstance.interceptors.request.eject(fileApiRequestInterceptorId)
  }
  fileApiRequestInterceptorId = fileApiInstance.interceptors.request.use(
    requestInterceptor
  )

  if (afterLoginRequestInterceptorId !== null) {
    afterLoginInstance.interceptors.request.eject(
      afterLoginRequestInterceptorId
    )
  }
  afterLoginRequestInterceptorId = afterLoginInstance.interceptors.request.use(
    requestInterceptor
  )

  if (mainApiRequestInterceptorId !== null) {
    mainApiInstance.interceptors.request.eject(mainApiRequestInterceptorId)
  }
  mainApiRequestInterceptorId = mainApiInstance.interceptors.request.use(
    requestInterceptor
  )
}

// ====== instance for Auth0 authentication api =====
const authApiInstance = axios.create({
  baseURL: `https://${AUTH_PROVIDER_DOMAIN}`
})
// ====================================

export {
  userApiInstance,
  afterLoginInstance,
  fileApiInstance,
  mainApiInstance,
  beforeLoginInstance,
  authApiInstance,
  injectRequestInterceptor
}
